<template>
  <div>
    <div v-if="!filterCriteria || !filterCriteria.length">
      <PresetFilter
        v-for="(quickFilter, idx) in quickFilters"
        :key="quickFilter.field"
        :last="idx === quickFilters.length"
        :filter="quickFilter.displayName"
        @click="addANDRule(0, quickFilter.tagId, quickFilter.field)"
      />

      <btn 
        type="primary"
        size="sm"
        class="m-b-10"
        title="Click to add filter"
        @click="addORRule()"
      >
        <i class="fa fa-plus" />
        {{ $t('FILTER_TEXT') }}
      </btn>
    </div>
    <div
      v-for="(andCriteria, andIndex) in filterCriteria"
      :key="andCriteria.key"
      class="filter-item filter-item-and-condition slide-down"
    >
      <AndCriteria
        :and-criteria="andCriteria.tagCriteria"
        :and-index="andIndex"
        :is-read-only="isReadOnly"
        :is-full-width="isFullWidth"
        :is-summary-view="isSummaryView"
        :available-tags="availableTags"
        :form-name-for-user-settings="formNameForUserSettings"
        :use-in-reporting-filters="useInReportingFilters"
        :values-for-reporting-filter="valuesForReportingFilter"
        :event-category="eventCategory"
        @change="(andCriteria, andIndex) => handleAndChange(andCriteria, andIndex)"
        @addORRule="addORRule"
        @addANDRule="addANDRule"
      />
    </div>
  </div>
</template>

<script>
import analyticsMixinFactory from '@/core/mixins/analyticsMixinFactory';
import AndCriteria from './AndCriteria';
import messages from './locales';
import sharedMessages from '@/core/locales';
import { filterService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import PresetFilter from './PresetFilter';

const OR_RULE_ADD_ACTION = 'or-rule-add';
const AND_RULE_ADD_ACTION = 'and-rule-add';

export default {
  components: { AndCriteria, PresetFilter },
  mixins: [
    analyticsMixinFactory('')
  ],
  props: {
    value: {
      type: Array,
      default() { return []; }
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    isFullWidth: {
      type: Boolean,
      default: false
    },
    isSummaryView: {
      type: Boolean,
      default: false
    },
    isMobileView: {
      type: Boolean,
      default: false
    },
    uSStates: {
      type: Array,
      default() { return []; }
    },
    formNameForUserSettings: {
      type: String,
      default: ''
    },
    availableTags: {
      type: Array,
      default() {
        return [];
      }
    },
    quickFilters: {
      type: Array,
      default() {
        return [];
      }
    },
    useInReportingFilters: {
      type: Boolean,
      default: false
    },
    valuesForReportingFilter: {
      type: Object,
      default() {
        return {};
      }
    },
    eventCategory: {
      type: String,
      default: 'insights'
    }
  },
  data() {
    return {
      filterCriteria: []
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.filterCriteria = newValue;
      }
    }
  },
  methods: {
    addORRule(andIndex) {
      if (typeof andIndex !== 'number') {
        this.addANDRule(0);
      } else if (this.filterCriteria.length >= andIndex + 1 && Array.isArray(this.filterCriteria[andIndex].tagCriteria)) {
        this.filterCriteria[andIndex].tagCriteria.push(filterService.getNewOrFilterCondition());
      }

      this.$emit('change', this.filterCriteria);
      this.$emit('input', this.filterCriteria);
      this.trackEvent(OR_RULE_ADD_ACTION, `AndIndex:${andIndex}`, this.eventCategory);
    },
    addANDRule(andIndex, filterTagId, columnName) {
      const newAndCondition = filterService.getNewAndFilterCondition(filterTagId, columnName);
      if (andIndex > -1 && this.filterCriteria.length >= andIndex + 1) {
        this.filterCriteria.splice(andIndex + 1, 0, newAndCondition);
      } else {
        this.filterCriteria.push(newAndCondition);
      }

      this.$emit('change', this.filterCriteria);
      this.$emit('input', this.filterCriteria);
      this.trackEvent(AND_RULE_ADD_ACTION, `AndIndex:${andIndex}`, this.eventCategory);
    },
    handleAndChange(andCriteria, andIndex) {
      if (this.filterCriteria.length >= andIndex + 1) {
        if (Array.isArray(andCriteria) && andCriteria.length === 0) {
          this.filterCriteria.splice(andIndex, 1);
        } else {
          this.$set(this.filterCriteria, andIndex, { tagCriteria: andCriteria, key: this.filterCriteria[andIndex].key });
        }

        this.$emit('change', this.filterCriteria);
        this.$emit('input', this.filterCriteria);
      }
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>

<style lang="scss" scoped>
.filter-item-and-condition {
  margin-top: 20px;

  &:first-child {
    margin-top: 0 !important;
  }

  &:not(:first-of-type) {
    &:after {
      background: var(--component-widget-panel__holder-bg);
      font-size: 1.4em;
      top: -13px;
    }
  }
}
</style>